import React from 'react';
import { Badge } from '@shopify/polaris';

export const ActiveBadge = ({active}) => {
    return <Badge status={active ? 'success' : 'warning'}>{active ? 'Active' : 'Inactive'}</Badge>
}